import { html, nothing } from "lit";
import { ClinicalPathwaysActionMenu } from "./clinical-pathways-action-menu";

export const template = (props: ClinicalPathwaysActionMenu) => {
  return html`
    <div class="item" ?expanded=${props.showText}>
      <div class="icon-label">
        <dss-icon icon=${props.icon} size="md"></dss-icon>
        ${props.showText ? html`<span>${props.label}</span>` : ""}
        ${
          !props.showText
            ? html`
          <dss-tooltip position="right">
            ${props.label}
          </dss-tooltip>`
            : nothing
        }
      </div>
      <dss-action-menu id="clinical-pathways-sidenav-region-container" slot="content" >
      </dss-action-menu>
      ${props.showText ? html`<dss-icon icon="chevron_right" size="md"></dss-icon>` : nothing}
    </div>
  `;
};
